import { StringsEnumDimension } from '@orus.eu/dimensions'
import { mrphProductVersions } from '@orus.eu/product'

export const mrphProductVersionDimension = new StringsEnumDimension({
  name: 'mrphProductVersion',
  displayKeys: { name: 'dimension_name_mrph_product_version' },
  values: mrphProductVersions,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
